export default __webpack_public_path__ + "static/media/new_releases.ae2e5fed.svg";